import React, { useState } from 'react';

interface PasswordFormProps {
    onSubmit: (currentPassword: string, newPassword: string) => void;
}

export const PasswordForm: React.FC<PasswordFormProps> = ({ onSubmit }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const isValid =
        currentPassword.length >= 8 &&
        newPassword.length >= 8 &&
        newPassword === confirmPassword &&
        currentPassword !== newPassword;

    const handleSubmit = () => {
        if (isValid) {
            onSubmit(currentPassword, newPassword);
        }
    };

    return (
        <>
            <div className="change-password-description">
                보안을 위해 주기적으로 비밀번호를 변경해주세요.
            </div>

            <div className="form-section">
                {/* 현재 비밀번호 */}
                <div className="form-group">
                    <label htmlFor="current-password">
                        현재 비밀번호 <span className="required">*</span>
                    </label>
                    <div className="password-input-wrapper">
                        <input
                            id="current-password"
                            type={showCurrentPassword ? "text" : "password"}
                            placeholder="현재 비밀번호를 입력하세요"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            className="input-field"
                        />
                        <button
                            type="button"
                            className="password-toggle"
                            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                        >
                            {showCurrentPassword ? '🙈' : '👁️'}
                        </button>
                    </div>
                </div>

                {/* 새 비밀번호 */}
                <div className="form-group">
                    <label htmlFor="new-password">
                        새 비밀번호 <span className="required">*</span>
                    </label>
                    <div className="password-input-wrapper">
                        <input
                            id="new-password"
                            type={showNewPassword ? "text" : "password"}
                            placeholder="8자 이상 입력하세요"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="input-field"
                        />
                        <button
                            type="button"
                            className="password-toggle"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                        >
                            {showNewPassword ? '🙈' : '👁️'}
                        </button>
                    </div>
                    {newPassword.length > 0 && newPassword.length < 8 && (
                        <div className="validation-message error">
                            비밀번호는 8자 이상이어야 합니다
                        </div>
                    )}
                    {newPassword.length >= 8 && currentPassword === newPassword && (
                        <div className="validation-message error">
                            현재 비밀번호와 다른 비밀번호를 입력하세요
                        </div>
                    )}
                </div>

                {/* 비밀번호 확인 */}
                <div className="form-group">
                    <label htmlFor="confirm-password">
                        비밀번호 확인 <span className="required">*</span>
                    </label>
                    <div className="password-input-wrapper">
                        <input
                            id="confirm-password"
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="비밀번호를 다시 입력하세요"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="input-field"
                        />
                        <button
                            type="button"
                            className="password-toggle"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                            {showConfirmPassword ? '🙈' : '👁️'}
                        </button>
                    </div>
                    {confirmPassword.length > 0 && newPassword !== confirmPassword && (
                        <div className="validation-message error">
                            비밀번호가 일치하지 않습니다
                        </div>
                    )}
                    {confirmPassword.length > 0 && newPassword === confirmPassword && (
                        <div className="validation-message success">
                            비밀번호가 일치합니다
                        </div>
                    )}
                </div>
            </div>

            <div className="password-requirements">
                <p className="requirements-title">비밀번호 요구사항</p>
                <ul className="requirements-list">
                    <li>8자 이상 입력</li>
                    <li>영문, 숫자 조합 권장</li>
                    <li>현재 비밀번호와 다른 비밀번호 사용</li>
                </ul>
            </div>

            <button
                className="submit-button"
                onClick={handleSubmit}
                disabled={!isValid}
            >
                비밀번호 변경
            </button>
        </>
    );
};
